import { getServerApiBaseUrl } from "@/lib/serverApiBaseUrl";

/**
 * Resolves the API base URL per runtime.
 *
 * In the browser, calls go through the web app's OWN origin (`/api/v1/`), which
 * a Next.js rewrite proxies to the backend. This keeps the session cookie
 * first-party to the web domain so the Next.js middleware (which reads
 * `wos_session`) works even when the API is hosted on a different domain
 * (e.g. Railway, where `*.up.railway.app` hosts can't share cookies).
 *
 * On the server (SSG/SSR), a relative URL can't be resolved, so the absolute
 * backend URL is used — preferring the internal `SERVER_API_BASE_URL` (reachable
 * over the Docker network) and falling back to `NEXT_PUBLIC_API_BASE_URL`.
 */
const BROWSER_API_BASE = "/api/v1/";

export function apiBaseUrl(): string {
  if (typeof window !== "undefined") return BROWSER_API_BASE;
  const server = getServerApiBaseUrl();
  return server ? `${server}/` : BROWSER_API_BASE;
}
